import { render } from "./Admin.vue?vue&type=template&id=66ec1c7e"
import script from "./admin.js?vue&type=script&lang=js&external"
export * from "./admin.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__